import {IUserAuthenticationRestClient} from "./i-user-authentication-rest.client";
import {Injectable} from "@angular/core";
import {IResetPasswordRequest} from "./requests/i-reset-password-request";
import {firstValueFrom, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {IResetPasswordResponse} from "./responses/i-reset-password-response";
import {ILoginAttempt} from "./responses/i-login-attempt";
import {IDeleteAccountPreview} from "./responses/i-delete-account-preview";
import {IOkResponse} from "@zaeper/communication-lib";
import {HostUtil} from "../../../utils/host-util";
import {ICurrentUser} from "../../../models/i-current-user";
import {ARestClient} from "@zaeper/communication-lib";

@Injectable()
export class UserAuthenticationRestClient extends ARestClient implements IUserAuthenticationRestClient {
  constructor(private _httpClient: HttpClient) {
    super();
  }

  public getCurrentUser(): Promise<ICurrentUser> {
    const endpointUrl: string = super.getEndpointUrl(HostUtil.getUserApiEndpointUrl(), "v1/current-user");

    return firstValueFrom(this._httpClient.get(endpointUrl, {withCredentials: true}) as Observable<ICurrentUser>);
  }

  public sendResetPasswordRequest(resetPasswordRequest: IResetPasswordRequest): Promise<IResetPasswordResponse> {
    const endpointUrl: string = super.getEndpointUrl(HostUtil.getAuthenticationApiEndpointUrl(), "v1/forgot-password");

    return firstValueFrom(this._httpClient.post(endpointUrl, resetPasswordRequest) as Observable<IResetPasswordResponse>);
  }

  public getLoginAttempts(): Promise<ILoginAttempt[]> {
    const endpointUrl: string = super.getEndpointUrl(HostUtil.getAuthenticationApiEndpointUrl(), "v1/login-attempts");

    return firstValueFrom(this._httpClient.get(endpointUrl, {withCredentials: true}) as Observable<ILoginAttempt[]>);
  }

  public logout(): Promise<IOkResponse> {
    const endpointUrl: string = super.getEndpointUrl(HostUtil.getAuthenticationApiEndpointUrl(), "v1/logout");

    return firstValueFrom(this._httpClient.post(endpointUrl, {}, {
      withCredentials: true
    }) as Observable<IOkResponse>);
  }

  public getDeleteAccountPreview(): Promise<IDeleteAccountPreview> {
    const endpointUrl: string = super.getEndpointUrl(HostUtil.getAuthenticationApiEndpointUrl(), "v1/account/delete-preview");

    return firstValueFrom(this._httpClient.get(endpointUrl, {withCredentials: true}) as Observable<IDeleteAccountPreview>);
  }

  public deleteAccount(): Promise<IOkResponse> {
    const endpointUrl: string = super.getEndpointUrl(HostUtil.getAuthenticationApiEndpointUrl(), "v1/account/delete");

    return firstValueFrom(this._httpClient.post(endpointUrl, {}, {withCredentials: true}) as Observable<IOkResponse>);
  }

  public updateColorSchemePreference(colorSchemePreference: string): Promise<IOkResponse> {
    const endpointUrl: string = super.getEndpointUrl(HostUtil.getAuthenticationApiEndpointUrl(), "v1/user/color-scheme-preference");

    return firstValueFrom(this._httpClient.put(endpointUrl, {colorSchemePreference}, {withCredentials: true}) as Observable<IOkResponse>);
  }
}
